export default "__VITE_ASSET__CIs47_$m__"